import React, { Component } from 'react';

import Input from './Input.js';
import Textarea from './Textarea.js';
import Button from './Button.js';
import FileUploader from './FileUploader.js';
import './ObjectController.css';

import firebase from './fire.js';

const storage = firebase.storage();


class ObjectController extends Component {

  constructor(props){
    super(props);

    this.objectId = (this.props.id) ? this.props.id : null;


    this.state = {
      editing:true,
      data: this.props.data
    }

    this.infoFields = [
      {
        id: "price",
        title: "Pris"
      },
      {
        id: "fee",
        title: "Avgift"
      },
      {
        id: "rooms",
        title: "Antal rum",
        type:"number"
      },
      {
        id: "property",
        title: "Bostadstyp"
      },
      {
        id: "living_space",
        title: "Boarea"
      },
      {
        id: "biarea",
        title: "Biarea"
      },
      {
        id: "yard_area",
        title: "Tomtarea"
      },
      {
        id: "operating_cost",
        title: "Driftkostnad"
      },



    ];

    this.getObjectId = this.getObjectId.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.uploadFile = this.uploadFile.bind(this);
    this.saveDataToDatabase = this.saveDataToDatabase.bind(this);
  }

  componentWillReceiveProps(props, state){

    this.objectId = (props.id) ? props.id : null;

    console.log('componentWillReceiveProps: ', this.objectId);

    if(this.objectId){
      // this.props.saveObject(this.props.data);
    }
  }

  getObjectId(currentTarget){
    let objectId = currentTarget.getAttribute('objectid');

    do {
      currentTarget = currentTarget.parentNode;
      objectId = currentTarget.getAttribute('objectid');
    }
    while(( objectId === undefined || objectId === null ));

    return objectId;
  }

  handleSaveClick(){

    this.props.saveObject(this.state.data);

    this.setState({
      editing:false
    })
  }

  handleTextChange(id, val){

    console.log('changing text: ', this.objectId, id, val);
    let _data = this.state.data;
    console.log('_data.items[this.objectId][id]', _data.items[this.objectId][id]);
    console.log('_data.items[this.objectId].info[id]', _data.items[this.objectId].info[id]);

    if(_data.items[this.objectId][id] !== undefined){
      _data.items[this.objectId][id] = val;
      console.log('_data.items[this.objectId][id]', _data.items[this.objectId][id]);
    }
    else if(_data.items[this.objectId].info[id] !== undefined){
      _data.items[this.objectId].info[id].text = val;
      console.log('andra');
    }
    else {
      _data.items[this.objectId][id] = val;
    }

    console.log('final data: ', _data);

    this.setState({
      data: _data,
      editing:true
    });
  }

  handleStatusChange(e){


    let val = e.target.value;
    console.log('val: ', val);

    let _data = this.state.data;
    _data.items[this.objectId].status = val;

    this.setState({
      data: _data,
      editing:true
    });

  }

  getRandomId(){
    return Math.random().toString(36).substr(2, 9);
  }

  saveDataToDatabase(newData){
    // this.firebaseRef = firebase.database();

    // this.firebaseRef.ref('projects/' + this.props.projectId ).set(newData);

    this.setState({
      data: newData,
      editing:true
    });
  }

  uploadFile(id, file){

    let fileName = id + "-" +this.getRandomId() + "-" + file.name;
    console.log('laddar upp fil', fileName);

    // Create a root reference
    var storageRef = firebase.storage().ref();
    //
    // // Create a reference to 'mountains.jpg'
    var fileRef = storageRef.child(fileName);
    //
    // // Create a reference to 'images/mountains.jpg'
    var fileFolderRef = storageRef.child('documents/'+fileName);
    //
    // // While the file names are the same, the references point to different files
    // mountainsRef.name === mountainImagesRef.name            // true
    // mountainsRef.fullPath === mountainImagesRef.fullPath    // false


    fileFolderRef.put(file).then(function(snapshot) {
      console.log('Uploaded a blob or file!', snapshot);
      snapshot.ref.getDownloadURL().then(function(downloadURL) {
        console.log('downloadURL: ', downloadURL);
        let _data = this.state.data;

        _data.items[id].link = downloadURL;
        console.log('this new data', _data);
         this.saveDataToDatabase(_data);

      }.bind(this))
    }.bind(this));

    // // Create the file metadata
    // var metadata = {
    //   contentType: 'image/jpeg'
    // };
    //
    //
    // // Upload file and metadata to the object 'images/mountains.jpg'
    // var uploadTask = storageRef.child('images/' + _name).put(file, metadata);
    //
    // // Listen for state changes, errors, and completion of the upload.
    // uploadTask.on('state_changed', function(snapshot) {
    //     // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    //     var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    //     this.setState({ loading: true });
    //
    //     console.log('Upload is ' + progress + '% done');
    //     switch (snapshot.state) {
    //       case 'paused':
    //         console.log('Upload is paused');
    //         break;
    //       case 'running':
    //         console.log('Upload is running ' + progress);
    //         break;
    //     }
    //   }.bind(this), function(error) {
    //
    //   switch (error.code) {
    //     case 'storage/unauthorized':
    //       // User doesn't have permission to access the object
    //       break;
    //
    //     case 'storage/canceled':
    //       // User canceled the upload
    //       break;
    //
    //
    //     case 'storage/unknown':
    //       // Unknown error occurred, inspect error.serverResponse
    //       break;
    //   }
    // }, function() {
    //   // Upload completed successfully, now we can get the download URL
    //   uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
    //     console.log('File available at', downloadURL);
    //
    //     let _data = this.state.data;
    //     _data.project.images[chosenImgId] = downloadURL;
    //
    //     this.setState({
    //       loading: false,
    //       data: _data
    //      })
    //
    //      this.saveDataToDatabase(_data);
    //
    //      let newParentState = { activeImgId: chosenImgId};
    //      this.props.updateSpecificParentState(newParentState);
    //
    //
    //     // this.setState({ loading: false })
    //
    //   }.bind(this));
    // }.bind(this));
  }

  countTotalClicks(users){

    let total = 0;
    if(users){
      Object.keys(users).map((userId)=>{
        total += users[userId].clicks;
      })
    }
    return total;
  }

  render() {
    let thisObject = this.state.data.items[this.objectId];

    console.log('users: ', thisObject.users);

    return (
      <div>
          <div objectid={this.objectId} className="object-editor flex-col">

            <span className="date">Skapad {thisObject.date}</span>

            <h3 className={this.props.user.role === "admin" ? "hidden": ""}>{thisObject.title}</h3>
            <div className="clicks">
              <span>Antal unika klick: {thisObject.users ? Object.keys(thisObject.users).length : '0'}</span>
              <span>Totalt antal klick: {this.countTotalClicks(thisObject.users)}</span>
            </div>
            <div className="flex-row align-top">
              <div className="flex-col">

                <div className={this.props.user.role === "admin" ? "": "hidden"}>
                  <Input id="title" type="text" label="Titel" onChange={this.handleTextChange} value={thisObject.title}/>
                  <Textarea id="text" label="Infotext" onChange={this.handleTextChange} value={thisObject.text}/>
                  <div className="input-wrapper">
                  <Input id="link" type="text" label="Länk" onChange={this.handleTextChange} value={thisObject.link}/>
                  <FileUploader id={this.objectId} onUpload={this.uploadFile} label="Ladda upp ett nytt dokument" />
                  </div>

                </div>

              </div>
              <div className="flex-row flex-1">
                <div className={this.props.user.role === "admin" ? "flex-row flex-1": "hidden"}>
                  {
                    this.infoFields.map((item, key)=>(
                      <Input key={key} id={item.id} type={item.type} label={item.title} onChange={this.handleTextChange} value={thisObject.info[item.id].text}/>
                    ))
                  }
                </div>

                <div id="object-status" className="flex-row radio-buttons">
                  <label >
                    <input
                      onChange={this.handleStatusChange}
                      value="available" type="radio"
                      checked={thisObject.status === "available"}
                      name="object-status" />
                    Tillgänglig</label>
                  <label >
                    <input
                      onChange={this.handleStatusChange}
                      value="reserved" type="radio"
                      checked={thisObject.status === "reserved"}
                      name="object-status" />
                    Reserverad</label>
                  <label >
                    <input
                      onChange={this.handleStatusChange}
                      value="sold" type="radio"
                      checked={thisObject.status === "sold"}
                      name="object-status" />
                    Såld</label>
                </div>
                <Input id="email" type="text" label="Ansvarig mäklare" onChange={this.handleTextChange} value={thisObject.email||this.props.data.project.email}/>
                
              </div>

            </div>


            <div className={(this.state.editing)? '' : 'hidden'}>
              <Button onClick={this.handleSaveClick} text="Spara"/>
            </div>

          </div>
      </div>
    );

  }
}

export default ObjectController;



// WEBPACK FOOTER //
// ./src/ObjectController.js